import { COPY } from '@/shared/constants/copies';

export enum OnboardingScreen {
	USER_NAME = 'user_name',
	WORKSPACE_DETAILS = 'workspace_details',
}

export const ONBOARDING_SCREENS = [
	OnboardingScreen.USER_NAME,
	OnboardingScreen.WORKSPACE_DETAILS,
] as const;

export const SCREEN_CONFIG = {
	[OnboardingScreen.USER_NAME]: {
		title: "What's your name?",
		description: COPY.onboarding.nameHelp,
		component: 'UserNameScreen',
	},
	[OnboardingScreen.WORKSPACE_DETAILS]: {
		title: 'Set up your workspace',
		description: COPY.onboarding.workspaceHelp,
		component: 'WorkspaceDetailsScreen',
	},
} as const;

export const DEFAULT_SCREEN = OnboardingScreen.USER_NAME;

export const ONBOARDING_VIEW_WORKSPACE_JOIN = 'workspace_join';

export type OnboardingView = OnboardingScreen | typeof ONBOARDING_VIEW_WORKSPACE_JOIN;

export const ONBOARDING_SCREEN_HEADERS: Record<OnboardingView, { title: string; description?: string }> = {
	[OnboardingScreen.USER_NAME]: {
		title: COPY.onboarding.nameTitle,
	},
	[OnboardingScreen.WORKSPACE_DETAILS]: {
		title: 'Create a workspace',
		description: COPY.onboarding.workspaceIntro,
	},
	[ONBOARDING_VIEW_WORKSPACE_JOIN]: {
		title: 'Your team is already on Binary',
		description: COPY.onboarding.joinTeamHelp,
	},
};
